import { render } from "./StatementTable.vue?vue&type=template&id=5cd33e90"
import script from "./StatementTable.vue?vue&type=script&lang=js"
export * from "./StatementTable.vue?vue&type=script&lang=js"

import "./StatementTable.vue?vue&type=style&index=0&id=5cd33e90&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__